import Vue from 'vue';
import AjaxUtils from '../../util/ajax_utils';
import {
    ApckTrustRisksColumn,
    ApckTrustThirdpartyColumn,
    ApckTrustBasicCountColumn
} from './trust_columns';

export const ApckTrustDomainsTable = {
    props: {
        src: {
            type: String,
            default: '/trust/domain/list',
        },
    },
    data: function () {
        return {
            loading: false,
            cols: [
                {
                    data: 'hostname',
                    heading: 'Monitored Domain',
                    canSearch: true,
                    width: 260,
                },
                {
                    data: 'vulns',
                    heading: 'Vulnerabilities',
                    ctype: 'trust-risks',
                    width: 160,
                },
                {
                    data: 'thirdparty_count',
                    heading: 'Thirdparties',
                    ctype: 'trust-count',
                    width: 100,
                    center: true,
                },
                {
                    data: 'last_scanned_at',
                    heading: 'Last Scanned',
                    ctype: 'datecolumn',
                    width: 160,
                },
            ],
            actions: [
                {
                    title: 'View Details',
                    icon: 'fa-eye',
                    class: 'btn-secondary',
                    handler: this.viewDetails,
                    useOwnCol: true,
                    hideLabel: true,
                },
                {
                    title: 'Build Overview Report',
                    icon: 'fa-file-chart-pie',
                    class: 'btn-primary',
                    handler: this.buildReport,
                },
                {
                    title: 'Build Detailed Report (Long)',
                    icon: 'fa-file-chart-column',
                    class: 'btn-primary',
                    handler: this.buildFullReport,
                },
                {
                    title: 'Delete Domain',
                    icon: 'fa-trash',
                    class: 'btn-danger',
                    handler: this.deleteDomain,
                },
            ],
        }
    },
    methods: {
        buildReport: function (rec) {
            let cmp = this;
            let hostname = rec.get('hostname');
            console.log('Build report for:', hostname);
            cmp.generatePdfReport(hostname, '0');
        },
        buildFullReport: function (rec) {
            let cmp = this;
            let hostname = rec.get('hostname');
            console.log('Build report for:', hostname);
            cmp.generatePdfReport(hostname, '1');
        },
        generatePdfReport: function (hostname, full) {
            let cmp = this;
            cmp.loading = true;

            let params = {
                domain: hostname,
                full: full
            };

            let queryString = Object.keys(params).map(key =>
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            ).join('&');

            let url = '/trust/export/pdf?' + queryString;

            fetch(url, {
                credentials: 'same-origin'
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                let filename = `trust-report-${hostname}.pdf`;
                const contentDisposition = response.headers.get('Content-Disposition');
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }

                return response.blob().then(blob => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(link);

                cmp.loading = false;
            })
            .catch(error => {
                console.error('Error downloading report:', error);
                cmp.loading = false;
                window.location.href = url;
            });
        },
        viewDetails: function (rec) {
            console.log('View details for:', rec.get('hostname'));
            let domain_id = encodeURIComponent(rec.get('_id'));
            window.location.href = `/trust/domain/${domain_id}/view`;
        },
        deleteDomain: function (rec) {
            let cmp = this;
            let hostname = rec.get('hostname');
            let domain_id = rec.get('_id');
            
            window.app.confirm(
                `Are you sure you want to delete domain '${hostname}' and all associated relationships, vulnerabilities, and discovered trusts?`,
                'Delete Domain',
                function() {
                    cmp.loading = true;
                    
                    AjaxUtils.ajax_get({
                        url: '/trust/domain/delete?domain_id=' + encodeURIComponent(domain_id),
                        success: function(data) {
                            cmp.loading = false;
                            if (data && data.success) {
                                // Reload the table
                                if (cmp.$refs.trustDomainsTable && cmp.$refs.trustDomainsTable.store) {
                                    cmp.$refs.trustDomainsTable.store.reload();
                                }
                            }
                        },
                        fail: function(data) {
                            cmp.loading = false;
                        },
                        opts: {
                            dataType: 'json',
                        }
                    });
                }
            );
        },
        tableRowAction(row) {
            this.viewDetails(row);
        }
    },
    created: function () {
        // Register custom column components
        Vue.component('apck-trust-risks', ApckTrustRisksColumn);
        Vue.component('apck-trust-thirdparty', ApckTrustThirdpartyColumn);
        Vue.component('apck-trust-count', ApckTrustBasicCountColumn);
    },
    template: `
        <ui-page title="Trust Monitor Domains" stickyTitle>
            <template #content>
                <apck-table
                    ref="trustDomainsTable"
                    class="trust-domains-table"
                    :columns="cols"
                    :src="src"
                    :actions="actions"
                    :limit="50"
                    :border="false"
                    :show-toolbar="false"
                    :sglRowAction="tableRowAction"
                    newStyleTable
                />
                
                <ui-spinner :show="loading" theme="dark" />
            </template>
        </ui-page>
    `
};
